module.exports = __webpack_public_path__ + "img/default-news.0b136bfa.png";